export default __webpack_public_path__ + "static/media/icon-github.a22825f4.svg";